<template lang="pug">
  div
    CountryNudgeBanner
    HeaderTop
    RouterView
    Footer(v-if="showFooter")
    //- ModalPreloaderBanner is temporarily replaced by the marketplace promo (ModalMarket). Keep — do not delete.
      ModalPreloaderBanner(v-if="showPreloaderBanner")
    ModalMarket(v-if="showMarketPopup")
    ModalBeyondGravity(v-if="showBeyondGravity")
    ProductsModal
    RappersModal
    RidersModal
    FightersModal
    NewsModal
    NewsModalPoster
    ModalFeedback
    ModalCountry
    ModalBanner
</template>

<script>
import HeaderTop from '@/components/header/HeaderTop'
import HeaderHidden from '@/components/header/HeaderHidden'
import CountryNudgeBanner from '@/components/CountryNudgeBanner'
import Footer from '@/components/footer/Footer'
import ProductsModal from '@/components/products/ProductsModal'
import RidersModal from '@/components/riders/RidersModal'
import FightersModal from '@/components/fighters/FightersModal'
import NewsModal from '@/components/news/NewsModal'
import NewsModalPoster from '@/components/news/NewsModalPoster'
import ModalFeedback from '@/components/modals/ModalFeedback'
import RappersModal from '@/components/rappers/RappersModal'
import ModalCountry from '../components/modals/ModalCountry'
import ModalBanner from '@/components/modals/ModalBanner.vue'
import ModalBeyondGravity from '@/components/modals/ModalBeyondGravity.vue'
import ModalMarket from '@/components/modals/ModalMarket.vue'
import ModalPreloaderBanner from '@/components/modals/ModalPreloaderBanner.vue'
import { mapState } from 'vuex'

export default {
  name: 'MainLayout',
  components: {
    CountryNudgeBanner,
    ModalBanner,
    ModalMarket,
    ModalBeyondGravity,
    ModalPreloaderBanner,
    RappersModal,
    HeaderTop,
    HeaderHidden,
    Footer,
    ModalFeedback,
    ProductsModal,
    RidersModal,
    FightersModal,
    NewsModal,
    NewsModalPoster,
    ModalCountry
  },
  computed: {
    ...mapState('siteVersions', {
      siteVersion: 'item'
    }),
    showBeyondGravity: vm => ['kz', 'uz'].includes(vm.siteVersion.code),
    showFooter: vm => vm.$route.name !== '404',
    showPreloaderBanner: vm => vm.siteVersion.code === 'ru' && vm.$i18n.locale === 'ru',
    // Marketplace promo popup shows in place of the preloader banner (RU site + RU locale).
    showMarketPopup: vm => vm.siteVersion.code === 'ru' && vm.$i18n.locale === 'ru'
  }
}
</script>
